import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c4b84dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "party--toBe-held"
}
const _hoisted_2 = { className: "party-content" }
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = { className: "party-flex party-flex-title" }
const _hoisted_5 = { className: "party-title nowrap" }
const _hoisted_6 = {
  key: 0,
  className: "party-time nowrap",
  style: {"padding-left":"10px"}
}
const _hoisted_7 = {
  key: 1,
  className: "party-time nowrap"
}
const _hoisted_8 = { className: "party-gender-description" }
const _hoisted_9 = { className: "party-flex" }
const _hoisted_10 = { className: "party-left nowrap" }
const _hoisted_11 = { className: "party-left-text" }
const _hoisted_12 = { className: "nowrap male" }
const _hoisted_13 = {
  key: 0,
  className: "nowrap"
}
const _hoisted_14 = {
  key: 1,
  className: "nowrap"
}
const _hoisted_15 = { className: "nowrap fee" }
const _hoisted_16 = { className: "nowrap status" }
const _hoisted_17 = { className: "party-flex" }
const _hoisted_18 = { className: "party-left nowrap" }
const _hoisted_19 = { className: "party-left-text" }
const _hoisted_20 = { className: "nowrap female" }
const _hoisted_21 = {
  key: 0,
  className: "nowrap"
}
const _hoisted_22 = {
  key: 1,
  className: "nowrap"
}
const _hoisted_23 = { className: "nowrap fee" }
const _hoisted_24 = { className: "nowrap status" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { className: "party-footer" }, [
  /*#__PURE__*/_createTextVNode(" 詳細・参加申し込み"),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/design/search.png",
    alt: "search"
  })
], -1))
const _hoisted_26 = [
  _hoisted_25
]

import { formatDate } from "../../utils/date.js";

export default /*#__PURE__*/_defineComponent({
  props: {
  party: Object,
},
  setup(__props) {

const props = __props


const party = props.party;
const party_id = `party-id-${party.id}`;
const tagClass = party.online
  ? "party-tag party-online"
  : "party-tag party-offline";
const link_to = `/parties/${party.link}`;

const equal_val = (a, b) => {
  return JSON.stringify(a) == JSON.stringify(b);
};
const party_status = () => {
  let val = [party.left.men, party.left.women];
  if (equal_val(val, ["ok", "ok"])) {
    return "男性・女性募集中";
  }
  if (equal_val(val, ["ok", "few"])) {
    return "男性募集中・女性残りわずか";
  }
  if (equal_val(val, ["ok", "full"])) {
    return "男性募集中・女性キャンセル待ち";
  }
  if (equal_val(val, ["few", "ok"])) {
    return "男性残りわずか・女性募集中";
  }
  if (equal_val(val, ["few", "few"])) {
    return "男性残りわずか・女性残りわずか";
  }
  if (equal_val(val, ["few", "full"])) {
    return "男性残りわずか・女性キャンセル待ち";
  }
  if (equal_val(val, ["full", "ok"])) {
    return "男性キャンセル待ち・女性募集中";
  }
  if (equal_val(val, ["full", "few"])) {
    return "男性キャンセル待ち・女性残りわずか";
  }
  if (equal_val(val, ["full", "full"])) {
    return "男性キャンセル待ち・女性キャンセル待ち";
  }
};

const party_status_details = {
  stopped: "募集停止中",
  ok: "募集中",
  few: "残りわずか",
  full: "満席",
};
const status = party_status();

const party_symbol_men = `/design/party_${party.left.men}.png`;
const party_symbol_women = `/design/party_${party.left.women}.png`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(party).adjust_flag && _unref(party).hold_flag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " 開催決定！ "))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      className: "party-box",
      id: party_id
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(_unref(tagClass))
          }, _toDisplayString(_unref(party).online ? "オンライン開催" : "リアル開催"), 3),
          (_unref(party).adjust_flag)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_unref(tagClass)),
                style: {"margin-left":"8px","background-color":"#86a3ad"}
              }, " 日未定募集中 ", 2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(party).title.replace("+", " ")), 1),
          (_unref(party).adjust_flag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 参加者集まり次第、日程調整します "))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(formatDate)(new Date(_unref(party).dates), "yyyy/MM/dd HH:mm (aaa)") + "開始"), 1))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, " 男性（" + _toDisplayString(_unref(party).quantity_available_for_men) + "名） ", 1),
                (!_unref(party).no_age_limit && _unref(party).rating_age_for_men < 99)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(party).rating_age_for_men) + "才以下 ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, "年齢制限なし")),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(party).participation_fee_for_men.toLocaleString()) + "円 ", 1),
                _createElementVNode("div", _hoisted_16, [
                  _createTextVNode(_toDisplayString(party_status_details[_unref(party).left.men]) + " ", 1),
                  _createElementVNode("div", { className: "symbol" }, [
                    _createElementVNode("img", { src: party_symbol_men })
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, " 女性（" + _toDisplayString(_unref(party).quantity_available_for_women) + "名） ", 1),
                (!_unref(party).no_age_limit && _unref(party).rating_age_for_women < 99)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(party).rating_age_for_women) + "才以下 ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22, "年齢制限なし")),
                _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(party).participation_fee_for_women.toLocaleString()) + "円 ", 1),
                _createElementVNode("div", _hoisted_24, [
                  _createTextVNode(_toDisplayString(party_status_details[_unref(party).left.women]) + " ", 1),
                  _createElementVNode("div", { className: "symbol" }, [
                    _createElementVNode("img", { src: party_symbol_women })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("a", {
        target: "_self",
        href: link_to
      }, _hoisted_26)
    ])
  ], 64))
}
}

})